var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
    [
      _c("Header"),
      _c(
        "v-col",
        {
          staticClass: "pa-0",
          attrs: { id: "main_content_maxwidthset", cols: "12" },
        },
        [
          _c(
            "v-col",
            {
              staticClass: "ma-0 pa-5",
              attrs: { cols: "12", align: "center" },
            },
            [
              _c(
                "v-col",
                {
                  staticClass: "ma-0 pa-0 mt-15",
                  attrs: { cols: "12", id: "group_box" },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pa-2",
                      attrs: { cols: "12", id: "group_box_title" },
                    },
                    [
                      _vm._v(
                        " " + _vm._s(_vm.tsg("selectSplitScreenLayout")) + " "
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "ma-0 pa-0",
                          attrs: { id: "close_btn", cols: "auto" },
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "ma-0 pa-0",
                              attrs: {
                                width: "2rem",
                                height: "2rem",
                                id: "back_clean_btn",
                                elevation: "0",
                              },
                              on: { click: _vm.clickClose },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/images/popup_close.png"),
                                  id: "btn_img",
                                },
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "ma-0 pt-6 pb-6 pl-15 pr-15",
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-row",
                        {
                          staticClass: "ma-0 pa-0 pt-9 pb-9",
                          attrs: { align: "center" },
                        },
                        [
                          _c(
                            "v-col",
                            { staticClass: "ma-0 pa-0", attrs: { cols: "4" } },
                            [
                              _c("v-img", {
                                staticClass: "ma-0 pa-0 mb-4",
                                attrs: {
                                  "max-height": "6rem",
                                  "max-width": "8rem",
                                  src: require("@/assets/images/4view.png"),
                                },
                              }),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0 pa-0 pl-2 pr-2",
                                  attrs: {
                                    width: "auto",
                                    height: "2rem",
                                    id: "blue_btn",
                                    elevation: "0",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goCameraSelect(4)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "4" +
                                          _vm.tsg("createdLayoutWithCameras")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "ma-0 pa-0", attrs: { cols: "4" } },
                            [
                              _c("v-img", {
                                staticClass: "ma-0 pa-0 mb-4",
                                attrs: {
                                  "max-height": "6rem",
                                  "max-width": "8rem",
                                  src: require("@/assets/images/9view.png"),
                                },
                              }),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0 pa-0 pl-2 pr-2",
                                  attrs: {
                                    width: "auto",
                                    height: "2rem",
                                    id: "blue_btn",
                                    elevation: "0",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goCameraSelect(9)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "9" +
                                          _vm.tsg("createdLayoutWithCameras")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { staticClass: "ma-0 pa-0", attrs: { cols: "4" } },
                            [
                              _c("v-img", {
                                staticClass: "ma-0 pa-0 mb-4",
                                attrs: {
                                  "max-height": "6rem",
                                  "max-width": "8rem",
                                  src: require("@/assets/images/16view.png"),
                                },
                              }),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "ma-0 pa-0 pl-2 pr-2",
                                  attrs: {
                                    width: "auto",
                                    height: "2rem",
                                    id: "blue_btn",
                                    elevation: "0",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.goCameraSelect(16)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        "16" +
                                          _vm.tsg("createdLayoutWithCameras")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }